import { render, staticRenderFns } from "./ad-anchor-related-type.vue?vue&type=template&id=0db7cee4&scoped=true"
import script from "./ad-anchor-related-type.vue?vue&type=script&setup=true&lang=js"
export * from "./ad-anchor-related-type.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ad-anchor-related-type.vue?vue&type=style&index=0&id=0db7cee4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db7cee4",
  null
  
)

export default component.exports